var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "sort-controls mb-3" },
        [
          _c("span", { staticClass: "sort-label" }, [_vm._v("Ordenar per:")]),
          _vm._l(_vm.sortableColumns, function (column) {
            return _c(
              "button",
              {
                key: column.id,
                class: [
                  "btn",
                  "btn-sm",
                  "mx-1",
                  _vm.getSortButtonClass(column.id),
                ],
                attrs: { title: "Ordenar per " + _vm.$t(column.name) },
                on: {
                  click: function ($event) {
                    return _vm.sortBy(column.id)
                  },
                },
              },
              [
                _vm._v(" " + _vm._s(_vm.$t(column.name)) + " "),
                _vm.sortField === column.id
                  ? _c("span", { staticClass: "sort-icon" }, [
                      _vm._v(
                        " " + _vm._s(_vm.sortOrder === "asc" ? "↑" : "↓") + " "
                      ),
                    ])
                  : _vm._e(),
              ]
            )
          }),
          _vm.sortField
            ? _c(
                "button",
                {
                  staticClass: "btn btn-outline-secondary btn-sm mx-1",
                  attrs: { title: "Limpiar ordenación" },
                  on: {
                    click: function ($event) {
                      return _vm.clearSort()
                    },
                  },
                },
                [_vm._v(" Limpiar ")]
              )
            : _vm._e(),
        ],
        2
      ),
      _c("vue-data-table", {
        attrs: {
          "table-columns": _vm.columns,
          "table-rows": _vm.rows,
          "is-loading": _vm.isLoading,
          stickyTable: true,
          "empty-rows-message": _vm.$t("components.table.no_data"),
        },
        on: _vm._d({}, [_vm.needDataUpdateEvent, _vm.init]),
        scopedSlots: _vm._u([
          {
            key: "table-row",
            fn: function (props) {
              return [
                props.cell.getColumn.id == "employee.holidaysRemaining"
                  ? [_vm._v(" " + _vm._s(props.cell.getValue) + " ")]
                  : props.cell.getColumn.id == "employee.hourBalance"
                  ? [_vm._v(" " + _vm._s(props.cell.getValue) + " ")]
                  : props.cell.getColumn.id == "employee.fullName"
                  ? [
                      _c("div", [
                        _vm._v(" " + _vm._s(props.cell.getValue) + " "),
                      ]),
                      _c("div", [
                        _c(
                          "span",
                          { staticClass: "badge badge-pill badge-light pl-0" },
                          [
                            _vm._v(
                              _vm._s(props.cell.getRaw.employee.employeeCode) +
                                " "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  : !["actions"].includes(props.cell.getColumn.id)
                  ? [
                      _c("plan-week-or-monthItem-table-component", {
                        attrs: {
                          employeeData: props.cell.getByPathRaw,
                          employee: props.cell.getRaw.employee,
                        },
                      }),
                    ]
                  : _vm._e(),
              ]
            },
          },
          {
            key: "table-action-menu",
            fn: function (props) {
              return [
                _c(
                  "router-link",
                  {
                    staticClass: "dropdown-item",
                    attrs: {
                      to: {
                        name: "planing-team-validate",
                        params: { code: props.row.raw.employee.employeeCode },
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("pages.permission.validate_hours")) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.addAbsence(props.row.raw.employee)
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("pages.planing-team-validate.add_absence")
                        ) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.addWorkShift(props.row.raw.employee)
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("pages.planing-team-validate.add_workshift")
                        ) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "a",
                  {
                    staticClass: "dropdown-item",
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.addOvertimeNight(props.row.raw.employee)
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("pages.planing-team-validate.add_overtime")
                        ) +
                        " "
                    ),
                  ]
                ),
                _c(
                  "router-link",
                  {
                    staticClass: "dropdown-item",
                    attrs: {
                      to: {
                        name: "profile-employee",
                        params: { code: props.row.raw.employee.employeeCode },
                      },
                    },
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("pages.profile.tabs.personal_data.title")
                        ) +
                        " "
                    ),
                  ]
                ),
              ]
            },
          },
          {
            key: "description",
            fn: function () {
              return [
                _c("div", { staticClass: "row my-2" }, [
                  _c(
                    "div",
                    { staticClass: "col d-flex flex-wrap" },
                    [
                      _c("absence-justified-day-legend", {
                        staticClass: "m-1",
                      }),
                      _c("absence-unjustified-day-legend", {
                        staticClass: "m-1",
                      }),
                      _c("absence-confirm-waiting-day-legend", {
                        staticClass: "m-1",
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row my-2" }, [
                  _c(
                    "div",
                    { staticClass: "col d-flex flex-wrap" },
                    [
                      _c("vacations-approved-day-legend", {
                        staticClass: "m-1",
                      }),
                      _c("vacation-confirm-waiting-day-legend", {
                        staticClass: "m-1",
                      }),
                      _c("vacations-need-meeting-day-legend", {
                        staticClass: "m-1",
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row my-2" }, [
                  _c(
                    "div",
                    { staticClass: "col d-flex flex-wrap" },
                    [
                      _c("off-day-legend", { staticClass: "m-1" }),
                      _c("sick-day-legend", { staticClass: "m-1" }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row my-2" }, [
                  _c(
                    "div",
                    { staticClass: "col d-flex flex-wrap" },
                    [
                      _c("working-day-legend", { staticClass: "m-1" }),
                      _c("working-day-legend", {
                        staticClass: "m-1",
                        attrs: {
                          badge: 7,
                          title: _vm.$t(
                            "pages.permission.working_with_real_hours"
                          ),
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "row my-2" }, [
                  _c(
                    "div",
                    { staticClass: "col d-flex flex-wrap" },
                    [
                      _c("overtime-day-legend", {
                        staticClass: "m-1",
                        attrs: { badge: 1, withTitle: true },
                      }),
                      _c("overtime-night-legend", {
                        staticClass: "m-1",
                        attrs: { badge: 1, withTitle: true },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("day-detail-component"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }